import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomDatePickerDirective } from '../../../directives/custom-date-picker.directive';
import { MarbetesService } from '../../../services/marbetes.service';
import { Carnet, CarnetAllRequest, CarnetRequest, Health, HealthPolicyDataRequest, PolicyDataResquet, Travel, Vehicle } from '../../../interfaces/marbetes.interface';
import { InsuranceTableComponent } from '../../../componentes/insurance-table/insurance-table.component';
import { TableConfig } from '../../../interfaces/table-config.interface';
import { NotificationComponent } from '../../pagos/pagos-online/helpers/notification.component';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';
@Component({
  selector: 'app-impresion-marbetes',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CustomDatePickerDirective,
    InsuranceTableComponent,
    NotificationComponent
  ],
  templateUrl: './impresion-marbetes.component.html',
  styleUrl: './impresion-marbetes.component.css',
})
export class ImpresionMarbetesComponent {
  constructor(private marbetesService: MarbetesService,private gAnalytics:GoogleAnalyticsService) { }
  public CODIGO_RAMO_SEGURO_MEDICO = '13'

  // Propiedades del formulario
  public policy?: string;
  //                                                   //
  public unitFrom?: number;
  public unitTo?: number;
  public user: string = 'appsr'; // TEST USER VALUE
  public debtorCode?: number;

  public affiliateHolder?: number;
  public plantype?: number;

  // Propiedades para los campos autollenados
  public effectiveDate?: string;
  public validFrom?: string;
  public validTo?: string;

  public responseData?: Vehicle[] | Travel[] | Health[];
  public filteredData?: Vehicle[] | Travel[] | Health[];

  // Configuración de la tabla
  public noDataMessage: string = 'Ingrese número de póliza que desee buscar';
  public errorStatus?: number;

  public tableConfig?: TableConfig = { columns: [], showTotals: false };
  public tableConfigVehicle: TableConfig = {
    columns: [
      {
        key: 'vehicleNumber',
        label: 'Referente',
        type: 'year',
        sortable: true
      },
      {
        key: 'policyNumber',
        label: 'Póliza',
        sortable: true,
        type: 'poliza'
      },
      {
        key: 'insuredName',
        label: 'Asegurado',
        type: 'text',
      },
      {
        key: 'vehicleType',
        label: 'Tipo Vehículo',
        sortable: true,
        type: 'text',
      },
      {
        key: 'makeModelDescription',
        label: 'Marca',
        type: 'text',
        sortable: true,
      },
      {
        key: 'modelYear',
        label: 'Año',
        sortable: true,
        type: 'year',
      },
      {
        key: 'vinNumber',
        label: 'Chasis',
        type: 'text',
      },
      {
        key: 'download',
        label: 'Descargar',
        type: 'download',
      },
    ],
    showTotals: false,
  };
  public tableConfigTravel: TableConfig = {
    columns: [
      {
        key: 'insured',
        label: 'Número Asegurado',
        type: 'year',
        sortable: true
      },
      {
        key: 'insuredName',
        label: 'Asegurado',
        type: 'text',
        sortable: false
      },
      {
        key: 'birthDate',
        label: 'Fecha nacimiento',
        type: 'date',
        sortable: true
      },
      {
        key: 'policyNumber',
        label: 'Póliza',
        sortable: true,
        type: 'poliza'
      },
      {
        key: 'idNumber',
        label: 'Identificación',
        sortable: true,
        type: 'number',
      },
      {
        key: 'planName',
        label: 'Plan',
        type: 'text',
        sortable: true,
      },
      {
        key: 'download',
        label: 'Descargar',
        type: 'download',
      },
    ],
    showTotals: false,
  };
  public tableConfigHealth: TableConfig = {
    columns: [
      {
        key: 'codigo',
        label: 'Número Plástico',
        type: 'year',
        sortable: true
      },
      {
        key: 'nombre',
        label: 'Nombre',
        type: 'text',
        sortable: false
      },
      {
        key: 'apellido',
        label: 'Apellido',
        type: 'text',
        sortable: false
      },
      {
        key: 'contratante_Nombre',
        label: 'Contrante',
        sortable: false,
        type: 'text'
      },
      {
        key: 'plan_Descripcion',
        label: 'Plan',
        sortable: false,
        type: 'text',
      },
      {
        key: 'download',
        label: 'Descargar',
        type: 'download',
      },
    ],
    showTotals: false,
  };
  public isDataHealth: boolean = false;

  // Notificaciones
  public showNotification = false;
  public notificationType: 'success' | 'error' | 'warning' = 'success';
  public notificationTitle = '';
  public notificationMessage = '';

  // Submit formulario
  onSubmit() {
    const unformattedPolicy = this.policy?.replaceAll('-', '');

    if (!unformattedPolicy || unformattedPolicy?.length < 12 || unformattedPolicy.length > 12) {
      return this.onShowNotificacion('error', '', 'Ingrese una póliza válida');
    }

    const request: PolicyDataResquet = {
      PolicyNumber: unformattedPolicy,
      UserId: this.user!
    }
    // Lmpiar datos existentes;
    this.responseData = [];
    this.tableConfig = undefined;
    this.unitTo = undefined;
    this.unitFrom = undefined;

    // Obtener información general de la póliza
    this.marbetesService.getPolicyData(request).subscribe({
      next: (response) => {

        this.gAnalytics.trackEvent('busqueda_poliza_marbetes',{
        page:'/impresion-marbetes',
        action:'Busqueda de póliza para impresión de marbetes'
      })


        this.effectiveDate = response.changeEffectiveDate;
        this.validFrom = response.policyEffectiveDate;
        this.validTo = response.expirationDate;
        this.debtorCode = response.debtorCode;

        // Si la póliza no es de salud
        if (unformattedPolicy.slice(2, 4) !== this.CODIGO_RAMO_SEGURO_MEDICO) {
          this.isDataHealth = false;
          this.unitFrom = response.minVehicleNumber;
          this.unitTo = response.maxVehicleNumber;

          // Busqueda de información póliza de vehículo o viajero
          this.getMarbetes(unformattedPolicy);
        }
      },
      error: (error) => {
        console.log(error)
        this.onNoDataFound()
      }
    })

    // Busqueda de información póliza de salud
    if (unformattedPolicy.slice(2, 4) === this.CODIGO_RAMO_SEGURO_MEDICO) {
      const requestHealth: HealthPolicyDataRequest = {
        PolizaOrigen: unformattedPolicy
      }
      this.marbetesService.getHealthPolicyData(requestHealth).subscribe({
        next: (response) => {
          if (response.result.length) {
            this.isDataHealth = true;
            this.plantype = response.result[0].CodigoPlanOrigen;
            this.tableConfig = this.tableConfigHealth;

            const titulares: number[] = [];
            // Depuración de códigos de titulares
            response.result[0].Afiliados.forEach(record => {
              if (!titulares.includes(record.AfiliadoTitular)) titulares.push(record.AfiliadoTitular);
            });
            // Obtención de información final de carnets de afiliados
            titulares.forEach(codigoAfiliado => {
              this.affiliateHolder = codigoAfiliado;
              this.getMarbetes(unformattedPolicy, true);
            });
          } else {
            this.onNoDataFound()
          }
        },
        error: (error) => {
          console.log(error)
        },
      })
    }
  }

  getMarbetes(policy: string, isHealth: boolean = false) {
    let request: CarnetRequest = {
      policyNumber: policy,
      user: this.user!,
    }
    if (!isHealth) { // Poliza de viajero o vehículo
      const effectiveDateFormat = this.effectiveDate?.split('/').reverse().join('/');
      request = {
        ...request,
        unitFrom: this.unitFrom!,
        unitTo: this.unitTo!,
        effectiveDate: effectiveDateFormat!
      }
    } else {
      request = { // Poliza de Salud
        ...request,
        plantype: this.plantype,
        affiliateHolder: this.affiliateHolder
      }

    }
    this.marbetesService.getCarnets(request).subscribe({
      next: (response) => {
        // Verificar si no hay datos en ninguna póliza
        const noTravel = !response.travel?.length;
        const noVehicle = !response.vehicle?.length;
        const noHealth = !response.health?.length;

        if (noTravel && noVehicle && noHealth) {
          this.onNoDataFound();
          return;
        }

        // Función para procesar y asignar datos
        const assignData = (records: any[], tableConfig: any) => {
          this.responseData = records.map(record => ({ ...record, download: 'print' }));
          this.filteredData = structuredClone(this.responseData);
          this.tableConfig = tableConfig;
        };

        // Póliza de viajero
        if (!noTravel) {
          assignData(response.travel!, this.tableConfigTravel);
        }

        // Póliza de vehículo
        if (!noVehicle) {
          assignData(response.vehicle!, this.tableConfigVehicle);
        }

        // Póliza de salud
        if (!noHealth) {
          const coleccion = response.health[0]?.coleccion ?? [];

          if (coleccion.length) {
            const baseData = this.responseData ?? [];
            this.responseData = [...baseData, ...coleccion] as Health[];
            this.responseData.sort((a, d) => a.codigo - d.codigo);
            this.filteredData = structuredClone(this.responseData);
          }

          const healthData = this.responseData as Health[];
          if (healthData.length === 0) {
            this.onNoDataFound();
            return;
          }

          this.unitFrom = Math.min(...healthData.map(r => r.codigo));
          this.unitTo = Math.max(...healthData.map(r => r.codigo));
        }
      },
      error: (error) => {
        console.log(error)
      }
    })
  }

  // Descarga conjunta de todos los carnets de la póliza
  getAllMarbetes() {
    const formattedPolicy = this.policy!.replaceAll('-', '');
    const request: CarnetAllRequest = {
      process: 5, // fijo 5 para imprimir marbetes
      policy: formattedPolicy,
      cuser: this.user!,
      debtorCode: this.debtorCode!
    }

    this.marbetesService.getAllCarnets(request).subscribe({
      next: (response) => {
        if (response.carnets.length) {
          const record = response.carnets[0]
          this.onDownloadCarnet(record);

          this.gAnalytics.trackEvent('descarga_marbete',{
          page:'/impresion-marbetes',
          action:'Descarga de marbetes para impresión'
          })
        }
      },
      error: (error) => {
        console.log(error)
      }
    })
  }

  // Filtrado de data por unidad
  onFilterUnit() {
    if (!this.unitFrom || !this.unitTo) {
      this.filteredData = this.responseData;
      return;
    }
    if (this.unitFrom > this.unitTo) return;

    let filtered;
    const isVehicle = this.isVehicle(this.responseData![0]);
    if (isVehicle) {
      const data = structuredClone(this.responseData) as Vehicle[];
      filtered = data.filter(u => u['vehicleNumber'] >= this.unitFrom! && u['vehicleNumber'] <= this.unitTo!);
    }

    const isTravel = this.isTravel(this.responseData![0])
    if (isTravel) {
      const data = structuredClone(this.responseData) as Travel[];
      filtered = data.filter(u => u['insured'] >= this.unitFrom! && u['insured'] <= this.unitTo!);
    }

    const isHealth = this.isHealth(this.responseData![0]);
    if (isHealth) {
      const data = structuredClone(this.responseData) as Health[];
      filtered = data.filter(u => u['codigo'] >= this.unitFrom! && u['codigo'] <= this.unitTo!);
    }

    this.filteredData = filtered;
  }
  // Verificación de tipo de data para filtrado
  isTravel(object: Vehicle | Travel | Health) {
    const TravelKeys = ['policyNumber', 'insured', 'insuredName', 'birthDate', 'idNumber', 'planName'];
    return !TravelKeys.map(key => key in object).some(el => el === false);
  }
  isVehicle(object: Vehicle | Travel | Health) {
    const VehicleKeys = [
      'policyNumber',
      'vehicleNumber',
      'modelYear',
      'makeModelDescription',
      'vinNumber',
      'registrationNumber',
      'expirationDate',
      'insuredName',
      'vehicleType',
      'riskValue',
    ];
    return !VehicleKeys.map(key => key in object).some(el => el === false);
  }
  isHealth(object: Vehicle | Travel | Health) {
    const HealthKeys = [
      'codigo',
      'numero_Plastico',
      'tip_Ide_Id',
      'identificacion',
      'nombre',
      'apellido',
      'sexo',
      'fec_Nac',
      'edad',
      'compania',
      'tip_Pro',
      'subRamo',
      'secuencial',
      'plan',
      'plan_Descripcion',
      'tipo_Plan',
      'smiCode',
      'plan_Deducible',
      'contratante',
      'contratante_Nombre',

    ];
    return !HealthKeys.map(key => key in object).some(el => el === false);
  }

  onNoDataFound() {
    this.filteredData = [];
    this.responseData = [];
    this.tableConfig = { columns: [], showTotals: false };
    this.noDataMessage = 'No se encontraron registros para esta póliza'
  }
  // Limpieza de formulario
  onClearForm() {
    this.policy = '';
    this.responseData = [];
    this.filteredData = [];
    this.tableConfig = { columns: [], showTotals: false };
    this.isDataHealth = false;
    this.noDataMessage = 'Ingrese número de póliza que desee buscar';
    this.unitTo = undefined;
    this.unitFrom = undefined;
  }

  // Descarrga de carnet
  onDownloadCarnet(record: Vehicle | Travel | Carnet) {
    const anchor = document.createElement('a'); // Create an anchor element
    anchor.href = record.url; // Set the URL
    anchor.download = ''; // Set the download attribute (optional)
    anchor.target = '_blank'; // Open in a new tab (optional but recommended)
    document.body.appendChild(anchor); // Append the anchor to the body
    anchor.click(); // Simulate a click to trigger the download
    document.body.removeChild(anchor); // Remove the anchor from the body


     this.gAnalytics.trackEvent('descarga_carnet_marbetes',{
        page:'/impresion-marbetes',
        action:'Descarga de carnet individual para impresión de marbetes'
      })
  }

  // Validación de números den input
  onlyNumbers(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9-]/g, '').trim();
    input.value = this.formatPolicy(input.value);
  }

  // Formateo de la póliza
  formatPolicy(value: string) {
    const formatValue = value.replaceAll('-', '');
    if (!formatValue || formatValue.length < 12 || formatValue.length > 12) return formatValue;
    const str = formatValue.toString().trim();

    // Verificar si ya tiene el formato x-x-xxx-xxxxxx
    if (/^\d-\d-\d{3}-\d+$/.test(str)) return str;

    // Validar que solo contenga números
    if (!/^\d+$/.test(str)) return str;

    // Validar longitud mínima
    if (str.length < 10) return str;

    // Aplicar formato x-x-xxx-xxxxxx
    try {
      return `${str.slice(0, 1)}-${str.slice(1, 2)}-${str.slice(2, 5)}-${str.slice(5)}`;
    } catch {
      return str;
    }
  }

  // Mostrar notificación
  onShowNotificacion(
    type: 'success' | 'error' | 'warning',
    title: string,
    message: string
  ) {
    this.notificationType = type;
    this.notificationTitle = title;
    this.notificationMessage = message;
    this.showNotification = true;

    setTimeout(() => {
      this.showNotification = false;
    }, 5000);
  }

}
